import { makeVar } from '@apollo/client'

import { displayOption } from '@web/pages/checkin/checkin.constant'

export const isPaymentsExpandedVar = makeVar<boolean>(false)
export const displayCountVar = makeVar<number>(displayOption.DEFAULT_COUNT)

const resetPaymentsExpanded = () => isPaymentsExpandedVar(false)
const resetVisitsDisplayCount = () => displayCountVar(displayOption.DEFAULT_COUNT)

export const resetCheckInListExpanded = () => {
  resetPaymentsExpanded()
  resetVisitsDisplayCount()
}
